import React from 'react';
import { transitionAnimation } from 'lib/core';
import { NestedList } from 'lib/list';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { NavListItemsCollapsed, NavListItemsExpanded } from '../elements';
import { customNavScrollbar } from '../shared-styles';

const ListItemContainer = styled.div`
  ${transitionAnimation('width')};
  ${customNavScrollbar};
  background-color: ${({ theme }) => theme.color.gray[50].value};
  display: flex;
  flex-direction: column;
`;

const NavigationMenuV2 = ({
  activeItemId = '',
  className = 'nav-menu',
  dataTestId = undefined,
  expandedItemIds = {},
  isCollapsed = false,
  items,
  onExpand,
  onItemsExpandCollapse,
}) => {
  return (
    <ListItemContainer>
      {isCollapsed ? (
        <NavListItemsCollapsed
          activeItemId={activeItemId}
          className={className}
          dataTestId={dataTestId}
          expandedItemIds={expandedItemIds}
          items={items}
          onExpand={onExpand}
          onItemExpandCollapse={onItemsExpandCollapse}
        />
      ) : (
        <NavListItemsExpanded
          activeItemId={activeItemId}
          className={className}
          dataTestId={dataTestId}
          expandedItemIds={expandedItemIds}
          items={items}
          onItemExpandCollapse={onItemsExpandCollapse}
        />
      )}
    </ListItemContainer>
  );
};

NavigationMenuV2.propTypes = {
  /** Currently active navigation item id */
  activeItemId: PropTypes.string,
  /** Adds additional class to the component */
  className: PropTypes.string,
  /** Id value used for testing */
  dataTestId: PropTypes.string,
  /** Item ids that are currently expanded. This prop consists of object entries, where key is the id of the item
   * and value is true if item is expanded and falsy (false, null, undefined) if it is not */
  expandedItemIds: PropTypes.shape({}),
  /** If true, Menu is collapsed horizontally into a column of icons */
  isCollapsed: PropTypes.bool,
  /** Items of navigation menu */
  items: PropTypes.arrayOf(PropTypes.shape({ ...NestedList.propTypes.items })).isRequired,
  /** Callback for Menu horizontal expand from icons to List items */
  onExpand: PropTypes.func.isRequired,
  /** Callback for Menu List items to vertically expand or collapse */
  onItemsExpandCollapse: PropTypes.func.isRequired,
};

export { NavigationMenuV2 };
